import { SchedulePriorityFeedQuery } from './schedule_priority_feed_query';
import { ScheduleQuery } from './schedule_query';

angular
  .module('capability-ng-course-schedule')
  .service('ngScheduleQuery', ScheduleQuery)
  .service('ngSchedulePriorityFeedQuery', SchedulePriorityFeedQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/queries/queries_module.ts